<template>
  <div>
    <PageAllow controller="Receipt" action="history" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color" v-show="!currentItemMode">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 分账明细导出 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'Receipt',
                    'historySubAccountDetailsExport'
                  ) &&
                  options.obj_type == 1 &&
                  options.bill_types == 101 &&
                  settings.sub_account_enable &&
                  settings.sub_account_enable == 1 &&
                  settings.sub_account_modify_enable != 1
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="SubAccountExport()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("billRecords.SubAccountExport") }}
              </v-btn>
              <!-- 导出 -->
              <v-btn
                v-if="$permission.permissionAllow('Receipt', 'historyExport')"
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="ExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("billRecords.export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="bill_record_code"
                    v-model="options.bill_record_code"
                    @text="bill_record_code = $event"
                    :label="
                      $t('billRecords.bill_record_code') +
                      ' / ' +
                      $t('billRecords.Fields.bill_code')
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="key_word"
                    v-model="options.key_word"
                    @text="key_word = $event"
                    :label="
                      $t('billRecords.code_name', [
                        $t('billRecords.Fields.shop_name'),
                      ])
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="voucher_code"
                    v-model="options.voucher_code"
                    @text="voucher_code = $event"
                    :label="$t('billRecords.voucher_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherPayTypes
                    ref="pay_types"
                    v-model="payTypesSelected"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherObjType v-model="options.obj_type" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherBillType
                    v-model="options.bill_types"
                    :obj-type="options.obj_type"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.red_offset"
                    :label="$t('billRecords.isRedOffset.title')"
                    :items="$consts.redOffsetStatus"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 汇总 -->
        <div class="mx-4 mb-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  <h5>{{ $t("billRecords.billCount.receivable") }}</h5>
                  <v-spacer />
                  <h5 class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.in_type
                        ? bill_count.in_type.total
                        : 0 | formatMoney
                    }}
                  </h5>
                </v-card-title>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    {{ $t("billRecords.billCount.online_pay_total")
                    }}{{ $t("Global.colon") }}
                  </v-list-item-content>
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.in_type
                        ? bill_count.in_type.online_pay_total
                        : 0 | formatMoney
                    }}
                  </v-list-item-content>
                  <v-list-item-content>
                    {{ $t("billRecords.billCount.balance_total")
                    }}{{ $t("Global.colon") }}
                  </v-list-item-content>
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.in_type
                        ? bill_count.in_type.balance_total
                        : 0 | formatMoney
                    }}
                  </v-list-item-content>
                  <v-list-item-content>
                    {{ $t("billRecords.billCount.other_total")
                    }}{{ $t("Global.colon") }}
                  </v-list-item-content>
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.in_type
                        ? bill_count.in_type.other_total
                        : 0 | formatMoney
                    }}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  <h5>{{ $t("billRecords.billCount.payable") }}</h5>
                  <v-spacer />
                  <h5 class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.out_type
                        ? bill_count.out_type.total
                        : 0 | formatMoney
                    }}
                  </h5>
                </v-card-title>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    {{ $t("billRecords.billCount.online_pay_total")
                    }}{{ $t("Global.colon") }}
                  </v-list-item-content>
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.out_type
                        ? bill_count.out_type.online_pay_total
                        : 0 | formatMoney
                    }}
                  </v-list-item-content>
                  <v-list-item-content>
                    {{ $t("billRecords.billCount.balance_total")
                    }}{{ $t("Global.colon") }}
                  </v-list-item-content>
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.out_type
                        ? bill_count.out_type.balance_total
                        : 0 | formatMoney
                    }}
                  </v-list-item-content>
                  <v-list-item-content>
                    {{ $t("billRecords.billCount.other_total")
                    }}{{ $t("Global.colon") }}
                  </v-list-item-content>
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money")
                    }}{{
                      bill_count.out_type
                        ? bill_count.out_type.other_total
                        : 0 | formatMoney
                    }}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="bill_records"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.cash_discount="{ item }">
              <span v-if="item.cash_discount && item.cash_discount > 0">
                {{ $t("Global.money") }}{{ item.cash_discount | formatMoney }}
              </span>
            </template>
            <template v-slot:item.bill_record_code="{ item, index }">
              <span
                class="text-no-wrap caption font-weight-bold"
                :v-resize="!index ? $stickTableResizer() : null"
              >
                {{ item.bill_record_code }}
              </span>
              <br />
              <span
                v-if="item.payment_time"
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.payment_time | formatTime }}
              </span>
              <span
                v-else
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>

            <template v-slot:item.shop_name="{ item }">
              <span>
                <v-chip
                  small
                  label
                  :color="
                    item.bill ? item.bill.bill_obj_type : '' | billObjTypeColor
                  "
                  :text-color="
                    item.bill
                      ? item.bill.bill_obj_type
                      : '' | billObjTypeTextColor
                  "
                >
                  {{
                    item.bill ? item.bill.bill_obj_type : "" | billObjTypeText
                  }}
                </v-chip>
              </span>
              <span
                class="text-no-wrap caption font-weight-bold"
                v-if="item.bill"
              >
                {{
                  item.bill.bill_obj_type == 1
                    ? item.bill.shop.shop_name
                    : item.bill.bill_obj_type == 2
                      ? item.bill.supplier.supplier_name
                      : item.bill.bill_obj_type == 3
                       ? item.stock_name : ""
                }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                v-if="item.bill"
                style="margin-left: 64px"
              >
                {{
                  item.bill.bill_obj_type == 1
                    ? item.bill.shop.shop_code
                    : item.bill.bill_obj_type == 3
                        ? item.stock_code : ""
                }}
              </span>
            </template>
            <template v-slot:item.bill.bill_code="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.bill.bill_code }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.bill.bill_type_str }}
              </span>
              <v-chip
                v-if="item.bill.cancel_flg"
                x-small
                label
                outlined
                color="danger"
                >{{ $t("CRUD.cancelled") }}
              </v-chip>
            </template>
            <template v-slot:item.price="{ item }">
              <span v-if="item.io_type == 1">
                <v-chip small label color="primary" dark>
                  {{ $t("Receipt.Fields.collect") }}
                </v-chip>
                {{ $t("Global.money")
                }}{{ item.io_type == 1 ? item.price : "" | formatMoney }}
              </span>
            </template>
            <template v-slot:item.pay_price="{ item }">
              <span v-if="item.io_type == 2">
                <v-chip small label color="danger" dark>
                  {{ $t("Receipt.Fields.pay") }}
                </v-chip>
                {{ $t("Global.money")
                }}{{ item.io_type == 2 ? item.price : "" | formatMoney }}
              </span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("billRecords.Fields.detail") }}
                  </v-btn>
                </template>
                <span>{{ $t("billRecords.Fields.detail") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 操作跳转 -->
    <ReceiptHistoryDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getReceiptHistoryFromAPI()"
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
// import SearcherStock from "@/components/plugins/SearcherStock";
import BillRecords from "@/api/bill_records";
import Receipt from "@/api/receipt";
import ReceiptHistoryDetail from "./plugins/History";
// import DialogDelete from "@/components/plugins/DialogDelete";
// import SearcherStockArea from "@/components/plugins/SearcherStockArea";
import SearcherObjType from "@/components/plugins/SearcherObjType";
import SearcherBillType from "@/components/plugins/SearcherBillType";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherPayTypes from "@/components/plugins/SearcherPayTypes";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  bill_created_time_from: "",
  bill_created_time_to: "",
  bill_record_code: "",
  key_word: "",
  voucher_code: "",
  pay_types: [],
  obj_type: 1,
  bill_types: null,
  red_offset: [],
};

export default {
  data: () => ({
    bill_records: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("bill_records-options")
        ? sessionStorage.getItem("bill_records-options")
        : JSON.stringify(defaultOptions)
    ),
    bill_record_code: "",
    key_word: "",
    voucher_code: "",
    currentItemMode: null,
    currentItem: null,
    payTypesSelected: [],
    bill_count: {},
    typeFlg: 1,
  }),
  components: {
    Breadcrumbs,
    SearcherKeyword,
    PageAllow,
    ReceiptHistoryDetail,
    SearcherDatetimeRangeWithRadio,
    SearcherPayTypes,
    SearcherObjType,
    SearcherBillType,
    SearcherStatus,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.fundManagement"),
          disabled: false,
          href: "/receipts",
        },
        {
          text: i18n.t("Nav.receiptHistory"),
          disabled: true,
          href: "/receipt-history",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ReceiptBillAnalyze.Fields.trading_time"),
      },
      {
        key: "payment",
        text: i18n.t("ReceiptBillAnalyze.Fields.payment"),
      },
      {
        key: "bill_created",
        text: i18n.t("ReceiptBillAnalyze.Fields.bill_created_time"),
      },
    ],
    headers() {
      let headers = [
        {
          text: i18n.t("billRecords.Fields.bill_record_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "bill_record_code",
        },
        {
          text: i18n.t("billRecords.Fields.shop_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("billRecords.Fields.bill_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "bill.bill_code",
        },
        {
          text: i18n.t("billRecords.Fields.shop_code"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "operation_str",
        },
        {
          text: i18n.t("billRecords.Fields.pay_type"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "pay_type_str",
        },
        {
          text: i18n.t("billRecords.Fields.price"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "price",
        },
        {
          text: i18n.t("billRecords.Fields.pay"),
          align: "start",
          sortable: false,
          value: "pay_price",
          class: "text-no-wrap",
        }
      ];
      if (this.settings && this.settings.cash_discount) {
        headers.push({
          text: i18n.t("billRecords.Fields.cash_discount"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "cash_discount",
        })
      }
      headers.push(
        {
          text: i18n.t("billRecords.Fields.voucher_code"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "voucher_code",
        },
        {
          text: i18n.t("billRecords.Fields.invoice_fee"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "invoice_fee",
        },
        {
          text: i18n.t("billRecords.Fields.detail"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        }
      )
      return headers
    },
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("bill_records", ["payTypesSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "stocksSelected":
              this.stocksSelected = selected.value;
              break;
            case "stockAreasSelected":
              this.stockAreasSelected = selected.value;
              break;
            case "payTypesSelected":
              this.payTypesSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        bill_record_code: this.bill_record_code,
        key_word: this.key_word,
        voucher_code: this.voucher_code,
      });
    },
    resetSearch() {
      this.payTypesSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.bill_record_code].forEach((k) => {
        if (k) k.clear();
      });
      [this.$refs.key_word, this.$refs.voucher_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    getReceiptHistoryFromAPI() {
      BillRecords.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bill_records = response.data.bill_records;
            this.bill_count = response.data.bill_count;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    ExportExcel() {
      Receipt.historyExport(this.options);
    },
    SubAccountExport() {
      Receipt.historySubAccountDetailsExport(this.options);
    },
  },
  watch: {
    $route() {
      //   if (!this.$route.query.stock_id) {
      //     this.currentItemMode = null;
      //     this.currentItem = null;
      //   }
    },
    options: {
      deep: true,
      handler() {
        if (this.options.obj_type != this.typeFlg) {
          this.typeFlg = this.options.obj_type;
          this.options = Object.assign(
            {},
            JSON.parse(JSON.stringify(defaultOptions)),
            { page: 1, itemsPerPage: 30, obj_type: this.options.obj_type }
          );
        }
        this.getReceiptHistoryFromAPI();
        sessionStorage.setItem(
          "bill_records-options",
          JSON.stringify(this.options)
        );
      },
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    payTypesSelected: {
      // 支付类型搜索
      handler() {
        this.options.pay_types = this.payTypesSelected
          ? this.payTypesSelected.map((payType) => {
              return payType.key;
            })
          : "";
        sessionStorage.setItem(
          "bill_records-payTypesSelected",
          JSON.stringify(this.payTypesSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>